import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DB from "../../utils/db.json";
import MetaTagsSEO from "../../utils/metaTagsFunction";
import Loader from "../../components/loader";
import { AxiosResponse } from "axios";
import { APIResponseEntity } from "../../interface/apiResponse.interface";
import { APIGetAlbumsDetails } from "../../service/axios.service";
import { glassSubAlbumsNames } from "../../utils/constants";
import { AlbumsDetails } from "../../interface/libraryGallery.interface";
import { IsNullOrEmptyArray, IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "../../utils/nullCheck";

function Glass() {

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [albumsData, setAlbumsData] = useState<AlbumsDetails[] | null>(null)



  useEffect(() => {

    const fetchAlbumDetails = async (): Promise<void> => {

      setIsLoading(true);

      const resp: AxiosResponse<APIResponseEntity> = await APIGetAlbumsDetails(glassSubAlbumsNames);
      setIsLoading(false);

      if (!resp || resp.status !== 200 || !resp.data) {
        setAlbumsData(null);
        return;
      }

      const axiosResp: APIResponseEntity = resp.data;

      if (axiosResp.statusCode !== 200 || !axiosResp.data) {
        setAlbumsData(null);
        return
      }

      console.log("axiosResp:- ", axiosResp)

      if (IsNullOrEmptyArray(axiosResp.data.albumDetails)) {
        setAlbumsData(null);
        return
      }

      setAlbumsData(axiosResp.data.albumDetails)

    };

    fetchAlbumDetails();

  }, []);

  const redirectToLibrary = (albumName: string) : string => {

    let albumId : string = ""
    
    if(albumsData && !IsNullOrUndefined(albumsData)){

      let filteredAlbumData : AlbumsDetails | undefined = albumsData.find((item) => item.name===albumName);

      if(filteredAlbumData && !IsNullOrUndefined(filteredAlbumData)){
        albumId = filteredAlbumData._id       
      }      
    }   

    return albumId;
    
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <MetaTagsSEO metaTags={DB.glassMetaTags} title="Glass - JBGlass" />
      <section className="innerBannerWrapper">
        <img src="/assets/images/product-close-banner.webp" alt="" />
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="txt-white titleMain text-center">GLASS</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="glassWrapper py-100">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <p className="txt-gray">
                JB Glass has been a pioneer of innovation in the world of glass.
                If you can imagine it, we have it.
              </p>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
              <div className="glassHldr">
                <div className="glassImgHldr">
                  <img src="/assets/images/glass-img1.webp" alt="" />
                </div>
                <h3>Transparent</h3>
                <Link
                 to={
                  IsStringNullEmptyOrUndefined(redirectToLibrary("Transparent"))
                    ? "/library"
                    : `/library?albumId=${redirectToLibrary("Transparent")}`
                }               
                  className="btn btn-black-border1"
                >
                  View Photos
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
              <div className="glassHldr">
                <div className="glassImgHldr">
                  <img src="/assets/images/glass-img2.webp" alt="" />
                </div>
                <h3>Translucent</h3>
                <Link                 
                  to={
                    IsStringNullEmptyOrUndefined(redirectToLibrary("Translucent"))
                      ? "/library"
                      : `/library?albumId=${redirectToLibrary("Translucent")}`
                  }
                  className="btn btn-black-border1"

                >
                  View Photos
                </Link>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-4">
              <div className="glassHldr">
                <div className="glassImgHldr">
                  <img src="/assets/images/glass-img3.webp" alt="" />
                </div>
                <h3>Opaque</h3>
                <Link                 
                  to={
                    IsStringNullEmptyOrUndefined(redirectToLibrary("Opaque"))
                      ? "/library"
                      : `/library?albumId=${redirectToLibrary("Opaque")}`
                  }
                  className="btn btn-black-border1"
                >
                  View Photos
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Glass;
